module.exports = {"pagination":{"ListRuleGroupsNamespaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"ruleGroupsNamespaces"},"ListScrapers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"scrapers"},"ListWorkspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"workspaces"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/amp-2020-08-01.paginators.json
// module id = 394
// module chunks = 30